import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import './clientCodeDialog.less';
import ClientCodeDialogView from './clientCodeDialogView';

class ClientCodeDialogContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      popupErrors: {
        messages: ['Please set a valid client code first.'],
      },
      dialog_opened: true,
    };
    this.onClose = this.onClose.bind(this);
  }
  onClose = () => {
    this.setState({ dialog_opened: false });
    // unmount component to go over hot reload error about state change.
    ReactDOM.unmountComponentAtNode(document.getElementById('tab-menu-clientcode-dialog'));
  }

  render() {
    const popupErrors = this.props.popupErrors || this.state.popupErrors;
    return (
      <ClientCodeDialogView
        {...this.props}
        popupErrors={popupErrors}
        dialog_opened={this.state.dialog_opened}
        onClose={() => this.onClose()}
      />
    );
  }
}

ClientCodeDialogContainer.defaultProps = {
  errors: null,
  popupErrors: null,
};

ClientCodeDialogContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  errors: PropTypes.any,
  popupErrors: PropTypes.any,
};

function mapStateToProps(state) {
  return {
    popupErrors: state.get('validationErrors') ? state.get('validationErrors').toJS() : null,
  };
}

export default connect(mapStateToProps)(ClientCodeDialogContainer);



// WEBPACK FOOTER //
// ./src/components/case/client_code_dialog/clientCodeDialogContainer.js